import '../scss/main.scss'

// Other components
import { loadSlider } from '../components/slider-component'
import initTabs from '../components/tabs'
import initCustomCursor from '../components/cursor'
import initLogoVisibility from '../components/logo-animation'

document.addEventListener('DOMContentLoaded', () => {
  // Initialize custom cursor
  initCustomCursor()

  // Initialize logo visibility control
  const mainContainer = document.footer
  initLogoVisibility(mainContainer);

  // Initialize tabs for each section
  const tabSections = document.querySelectorAll('.tabs-collections')
  tabSections.forEach(section => {
    initTabs(section)
  })

  // Initialize sliders
  loadSlider()

  // Toggle map functionality
  const toggleMapButton = document.getElementById('toggle-map')
  if (toggleMapButton) {
    toggleMapButton.addEventListener('click', () => {
      const mapBox = document.querySelector('.map-box')
      if (mapBox) mapBox.classList.toggle('active')
    })
  }
})
